import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "byPageSelect",
  props: {
    // 标题
    title: {
      type: String,
      default: function _default() {
        return "选择器";
      }
    },
    // 左侧数据
    leftData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    collapseTags: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // 配置是否可多选
    multiple: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    clearable: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    size: {
      type: String,
      default: function _default() {
        return "small";
      }
    },
    width: {
      type: String,
      default: function _default() {
        return "100%";
      }
    },
    height: {
      type: String,
      default: function _default() {
        return "300px";
      }
    },
    selectWidth: {
      type: String,
      default: function _default() {
        return "width: 300px";
      }
    },
    pageSizes: {
      type: Array,
      default: function _default() {
        return [10, 20, 30, 50, 100];
      }
    },
    paramSearch: {
      type: Object,
      default: function _default() {
        return {
          current: 1,
          size: 10
        };
      }
    },
    total: {
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  //上面是父组件可传入参数
  data: function data() {
    return {
      loading: false,
      leftDataCopy: [],
      rightData: [],
      rightDataVal: [],
      singleVal: "",
      serveList: [],
      isShowSelect: false,
      // 是否显示选择器
      options: [],
      //select option选项
      returnDatas: [],
      //返回给父组件数组对象
      returnDataKeys: [] //返回父组件数组主键值

    };
  },
  computed: {
    selectLen: function selectLen() {
      return this.rightData.length;
    }
  },
  methods: {
    sureSelect: function sureSelect() {},
    handleCurrentChange: function handleCurrentChange() {
      this.$emit.apply(this, ["handleCurrentChange"].concat(Array.prototype.slice.call(arguments)));
    },
    handleSizeChange: function handleSizeChange() {
      this.$emit.apply(this, ["handleSizeChange"].concat(Array.prototype.slice.call(arguments)));
    },
    handleAlreadyChecked: function handleAlreadyChecked(checked) {
      if (!checked) {
        var data = this.rightData.filter(function (i) {
          return i.checked;
        });
        var obj = this.rightData.find(function (i) {
          return !i.checked;
        });
        this.leftDataCopy.forEach(function (i) {
          if (obj.value == i.value) {
            i.checked = false;
          }
        });
        this.rightData = data;
      }
    },
    handleChecked: function handleChecked(checked, value, item) {
      if (!checked) {
        var data = this.rightData.filter(function (i) {
          return value != i.value;
        });
        this.rightData = data;
      } else {
        this.rightData.push(item);
      }
    },
    selectClick: function selectClick() {
      return this.isShowSelect = !this.isShowSelect;
    },
    removeTag: function removeTag(value) {
      var data = this.rightData.filter(function (i) {
        return value != i.value;
      });
      this.rightData = data;
      this.leftDataCopy.forEach(function (i) {
        if (value == i.value) {
          i.checked = false;
        }
      });
    },
    setToading: function setToading(flag) {
      this.loading = flag;
    },
    valueSelect: function valueSelect(obj) {
      if (obj) {
        this.rightData = [obj];
        this.singleVal = obj.value;
        this.returnDataKeys = obj.value;
      } else {
        this.rightData = [];
        this.singleVal = "";
        this.returnDataKeys = "";
        this.$emit("setValue", "");
      }
    }
  },
  watch: {
    leftData: function leftData(val) {
      var _this = this;

      if (this.multiple) {
        this.leftDataCopy = val.map(function (i) {
          return _objectSpread(_objectSpread({}, i), {}, {
            checked: _this.rightDataVal.indexOf(i.value) == -1 ? false : true
          });
        });
      } else {
        this.leftDataCopy = val.map(function (i) {
          return _objectSpread({}, i);
        });
      }
    },
    rightData: function rightData(val) {
      this.rightDataVal = val.map(function (i) {
        return i.value;
      });
    },
    isShowSelect: function isShowSelect(val) {
      if (!val) {
        if (this.multiple) {
          this.returnDataKeys = this.rightData.map(function (i) {
            return i.value;
          });
        } else {
          this.returnDataKeys = this.rightData[0].value;
        }
      }
    },
    returnDataKeys: function returnDataKeys(val) {
      this.$emit("setValue", val);
    },
    singleVal: function singleVal(val) {
      if (this.leftDataCopy.length) {
        var obj = this.leftDataCopy.find(function (i) {
          return i.value == val;
        });
        this.rightData = [obj];
      } else {}
    }
  }
};